$(document).ready(function() {
  
  $('#upload').change(function() {
  var file = $('#upload')[0].files[0].name;
  $(this).next().find('.utext').text(file);
});

  $('.sidebar-block__heading').click();
  
  $("input[name='properties[Gender]']").change(function(){
            var radioValue = $("input[name='properties[Gender]']:checked").val();
            if(radioValue == 'For Women' ){
              $('.wp').show();
                 $('.mp').hide();
            }
    else{
      $('.wp').hide();
                 $('.mp').show();
    }
        });

 $('.wo_measure').click(function(){
   
 })
  $('.size_chart.women').click(function(){
    $('.CustomSizeChart.women').show();
  });
  $('.women .close_popup').click(function(){
   $('.CustomSizeChart.women').hide(); 
  });
   $('.size_chart.men').click(function(){
    $('.CustomSizeChart.men').show();
  });
  $('.men .close_popup').click(function(){
   $('.CustomSizeChart.men').hide(); 
  });
   $(".CustomSizeChart.women .size-chart-inches").click(function() {
    console.log("testing"), $(this).addClass("active"), $(".CustomSizeChart.women .size-chart-cm").removeClass("active"), $(".CustomSizeChart.women .size-chart-inches-target").removeClass("hidden"), $(".CustomSizeChart.women .size-chart-cm-target").addClass("hidden")
  });
  $(".CustomSizeChart.men .size-chart-inches").click(function() {
    console.log("testing"), $(this).addClass("active"), $(".CustomSizeChart.men .size-chart-cm").removeClass("active"), $(".CustomSizeChart.men .size-chart-inches-target").removeClass("hidden"), $(".CustomSizeChart.men .size-chart-cm-target").addClass("hidden")
  })
  $(".CustomSizeChart.women .size-chart-cm").click(function() {
    console.log("testing1"), $(this).addClass("active"), $(".CustomSizeChart.women .size-chart-inches").removeClass("active"), $(".CustomSizeChart.women .size-chart-inches-target").addClass("hidden"), $(".CustomSizeChart.women .size-chart-cm-target").removeClass("hidden")
  })
  $(".CustomSizeChart.men .size-chart-cm").click(function() {
    console.log("testing1"), $(this).addClass("active"), $(".CustomSizeChart.men .size-chart-inches").removeClass("active"), $(".CustomSizeChart.men .size-chart-inches-target").addClass("hidden"), $(".CustomSizeChart.men .size-chart-cm-target").removeClass("hidden")
  })
  $(".MoreInfo").click(function(){
    var getdata =   $(this).attr("alt");
    if(getdata.indexOf("mp4") != -1){

      getdata = '<video playsinline="" muted="" loop="" controls="" autoplay="" class="video" width="90%" id="pVideo"><source src="'+getdata+'" type="video/mp4"></video>';
    }
    else{
      getdata = '<img src="'+getdata+'" />';
    }
    $("#feature-dialog .MainConatiner").html(getdata);
    $('#feature-mask').show();
    $("#feature-boxes").show();
    $("#feature-dialog").show();
  })
  //if close button is clicked
  $('.feature-window .feature-close').click(function (e) {
    //Cancel the link behavior
    e.preventDefault();
    $("#feature-boxes").hide();
    $('#feature-mask').hide();
    $('.feature-window').hide();
  });		

  //if mask is clicked
  $('#feature-mask').click(function () {
    $(this).hide();
    $('.feature-window').hide();
    $("#feature-boxes").hide();
  });	
  //   $('#feature-boxes').click(function () {
  // 		$(this).hide();
  // 		$('.feature-window').hide();
  // 	});	
  $('[data-fancybox="images"]').fancybox({
    thumbs : {
      autoStart : true,
      axis: "x"
    },
    buttons: [
      "close"
    ],
    loop     : true,
    animationEffect: "fade",
    afterShow   : function(e){ 
      $("#tawkchat-container").css("bottom", "-70");
      $("div.doubly-float").hide();
    },
    afterClose  : function(e){
      $("div.doubly-float").show();
      $("#tawkchat-container").css("bottom", "0");
    },
    touch : {
      vertical : false // Allow to drag content vertically
    },
    hash : true,
    dblclickOutside: false
  })
//   $(".collection").bind("contextmenu", function(e) {
//     if (!$(e.target).closest(".customRight h1.product_name").length) return !1
//       }), 
  $(".TopMove").click(function() {
    document.body.scrollTop = 0, document.documentElement.scrollTop = 0
  }), $(".faq_tab .faq_link").click(function() {
    $(".faq_tab").each(function() {
      $(this).removeClass("ActiveDiv")
    }), $(this).parent(".faq_tab").addClass("ActiveDiv"), $(".faq_tab .faq_link").each(function() {
      $(this).removeClass("ActiveAnimated")
    }), $(this).addClass("ActiveAnimated")
  }), $(".faq_tab").click(function() {
    var e = $(this).attr("data-id");
    $(".faq_content_container .faq_content").each(function() {
      $(this).removeClass("ActiveContainer")
    }), $(".faq_content_container ." + e).addClass("ActiveContainer"), jQuery(".faq_content_container .faq_content").slideUp(), jQuery(".faq_content_container ." + e).slideDown()
  }), $(".faq_section").accordion({
    collapsible: !0,
    heightStyle: "content",
    active: !1
  }), setInterval(function() {
    $(".payment-ext-back-layer").removeClass("fadeIn"), $(".payment-icon-phone-layer").removeClass("fadeInUp"), $(".payment-icon-phone-tower").removeClass("fadeIn"), $(".payment-icon-phone-antena").removeClass("zoomInDown"), $(".payment-icon-two-rounds").removeClass("rollIn"), $(".payment-icon-c-card-one").removeClass("rotateInUpLeft"), $(".payment-icon-c-card-two").removeClass("rotateInUpRight")
  }, 9900), setInterval(function() {
    $(".payment-ext-back-layer").addClass("fadeIn"), $(".payment-icon-phone-layer").addClass("fadeInUp"), $(".payment-icon-phone-tower").addClass("fadeIn"), $(".payment-icon-phone-antena").addClass("zoomInDown"), $(".payment-icon-two-rounds").addClass("rollIn"), $(".payment-icon-c-card-one").addClass("rotateInUpLeft"), $(".payment-icon-c-card-two").addClass("rotateInUpRight")
  }, 1e3), $(".sizechart-cst .tabs_new_women li").click(function() {
    var e = $(this).children("a").attr("data-id");
    $(".tabs_new_women li").each(function() {
      $(this).removeClass("active")
    }), $(this).addClass("active"), $(".tabs_number_women").each(function() {
      $(this).attr("id") == e ? $(this).css("display", "block") : $(this).css("display", "none")
    })
  }), $(".sizechart-cst .tabs_new li").click(function() {
    var e = $(this).children("a").attr("data-id");
    $(".tabs_new li").each(function() {
      $(this).removeClass("active")
    }), $(this).addClass("active"), $(".tabs_number").each(function() {
      $(this).attr("id") == e ? $(this).css("display", "block") : $(this).css("display", "none")
    })
  }), "Made-to-Measure" == $(".customRight .swatch_options input:checked+.swatch-element").attr("data-value") ? ($(".customRight .dimensions").css("display", "block"), $(".customRight .dimensions_fields").css("display", "block"), $(".customRight .dimen_check_1").parent(".dimension_input").addClass("dimension_checked"), $(".customRight .dimen_check_1").prop("checked", !0)) : ($(".customRight .dimensions").css("display", "none"), $(".customRight .dimensions_fields").css("display", "none"), $(".customRight .dimen_check_1").parent(".dimension_input").removeClass("dimension_checked"), $(".customRight .dimen_check_1").prop("checked", !1)), $(".customRight .swatch .swatch-element").click(function() {
    "Made-to-Measure" == $(this).attr("data-value") ? ($(".customRight .dimensions").css("display", "block"), $(".customRight .dimensions_fields").css("display", "block"), $(".customRight .dimen_check_1").parent(".dimension_input").addClass("dimension_checked"), $(".customRight .dimen_check_1").prop("checked", !0), $(".customRight .dimen_check_1").trigger("click"), $(".customRight .dimen_check_1").parent(".dimension_input").trigger("click")) : ($(".customRight .dimensions").css("display", "none"), $(".customRight .dimensions_fields").css("display", "none"), $(".customRight .dimen_check_1").parent(".dimension_input").removeClass("dimension_checked"), $(".customRight .dimen_check_1").prop("checked", !1), $(".customRight .bust").val(""), $(".customRight .chest").val(""), $(".customRight .sleev").val(""), $(".customRight .waist").val(""), $(".customRight .shoulder").val(""), $(".customRight .length").val(""), $(".customRight .height").val(""), $(".customRight .hip").val(""))
  }), $("body").on("click", ".quick-shop .swatch .swatch-element", function() {
    "Made-to-Measure" == $(this).attr("data-value") ? ($(".quick-shop .dimensions").css("display", "block"), $(".quick-shop .dimensions_fields").css("display", "block"), $(".quick-shop .dimen_check_1").parent(".dimension_input").addClass("dimension_checked"), $(".quick-shop .dimen_check_1").prop("checked", !0), $(".quick-shop .dimen_check_1").trigger("click"), $(".quick-shop .dimen_check_1").parent(".dimension_input").trigger("click")) : ($(".quick-shop .dimensions").css("display", "none"), $(".quick-shop .dimensions_fields").css("display", "none"), $(".quick-shop .dimen_check_1").parent(".dimension_input").removeClass("dimension_checked"), $(".quick-shop .dimen_check_1").prop("checked", !1), $(".quick-shop .bust").val(""), $(".quick-shop .chest").val(""), $(".quick-shop .sleev").val(""), $(".quick-shop .waist").val(""), $(".quick-shop .shoulder").val(""), $(".quick-shop .length").val(""), $(".quick-shop .height").val(""), $(".quick-shop .hip").val(""))
  }), $(".dimension_input input").click(function() {
    "CM" == $(this).val() ? $(".size_demensions input").each(function() {
      $(this).attr("placeholder", "cm"), $(this).prev("p").children("span").html("(cm)")
    }) : $(".size_demensions input").each(function() {
      $(this).attr("placeholder", "in"), $(this).prev("p").children("span").html("(in)")
    }), $(".dimension_input input").each(function() {
      $(this).parent(".dimension_input").removeClass("dimension_checked")
    }), $(this).parent(".dimension_input").addClass("dimension_checked")
  });
  const e = $(".js-gallery-modal"),
        t = $(".js-gallery-carousel");
  $("body").on("click", ".js-quick-shop .gallery-cell", function() {
    var s = $(this).index();
    t.find(".is-nav-selected").removeClass("is-nav-selected"), $(this).addClass("is-nav-selected"), e.flickity("select", s), $(this).children("img").attr("alt").indexOf("Video.mp4")
  });
  var s = $(".product_gallery .gallery-cell.is-selected").attr("data-numberlarge");
  $(".product_gallery_nav .gallery-cell").each(function() {
    $(this).attr("data-number") == s && $(this).addClass("is-nav-selected")
  }), $(".product_gallery_nav .gallery-cell").click(function(e) {
    e.preventDefault();
    var t = $(this).attr("data-number");
    $(".product_gallery_nav .gallery-cell").each(function() {
      $(this).removeClass("is-nav-selected")
    }), $(this).addClass("is-nav-selected"), $(".product_gallery .gallery-cell").each(function() {
      $(this).attr("data-numberlarge") == t ? $(this).addClass("is-selected") : $(this).removeClass("is-selected")
    })
  }), $("#accordion").accordion({
    header: "h3",
    collapsible: !0,
    heightStyle: "content"
  }), $(".CustomSizeGuidPage #size_cart_men .measure .size-chart-inches").click(function() {
    console.log("testing"), $(this).addClass("active"), $(".CustomSizeGuidPage #size_cart_men .measure .size-chart-cm").removeClass("active"), $(".CustomSizeGuidPage #size_cart_men .size-chart-inches-target").removeClass("hidden"), $(".CustomSizeGuidPage #size_cart_men .size-chart-cm-target").addClass("hidden")
  }), $(".CustomSizeGuidPage #size_cart_men .measure .size-chart-cm").click(function() {
    console.log("testing1"), $(this).addClass("active"), $(".CustomSizeGuidPage #size_cart_men .measure .size-chart-inches").removeClass("active"), $(".CustomSizeGuidPage #size_cart_men .size-chart-inches-target").addClass("hidden"), $(".CustomSizeGuidPage #size_cart_men .size-chart-cm-target").removeClass("hidden")
  }), $(".CustomSizeGuidPage #size_cart_women .measure .size-chart-inches").click(function() {
    console.log("testin34g"), $(this).addClass("active"), $(".CustomSizeGuidPage #size_cart_women .measure .size-chart-cm").removeClass("active"), $(".CustomSizeGuidPage #size_cart_women .size-chart-inches-target").removeClass("hidden"), $(".CustomSizeGuidPage #size_cart_women .size-chart-cm-target").addClass("hidden")
  }), $(".CustomSizeGuidPage #size_cart_women .measure .size-chart-cm").click(function() {
    console.log("testing545"), $(this).addClass("active"), $(".CustomSizeGuidPage #size_cart_women .measure .size-chart-inches").removeClass("active"), $(".CustomSizeGuidPage #size_cart_women .size-chart-inches-target").addClass("hidden"), $(".CustomSizeGuidPage #size_cart_women .size-chart-cm-target").removeClass("hidden")
  }), $(".CustomSizeGuidPage .sizechart-cst .men_tableCus.size-chart-inches-target td").hover(function() {
    console.log("HOVER 1");
    var e = $(this).parent("tr").attr("data-max"),
        t = $(this).attr("data-number");
    $(this).toggleClass("dark_hover"), $(this).prevUntil(".first_colum", "td").toggleClass("light_hover"), $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
    $(this).parent("tr").attr("data-max");
    $(".CustomSizeGuidPage .men_tableCus.size-chart-inches-target thead tr th").each(function() {
      $(this).attr("data-number") == t && $(this).toggleClass("dark_hover")
    }), $(".CustomSizeGuidPage .men_tableCus.size-chart-inches-target tbody  tr").each(function(s) {
      s < e - 1 && $(this).children("td").each(function() {
        $(this).attr("data-number") == t && $(this).toggleClass("light_hover")
      })
    }), $(this).removeClass("light_hover")
  }), $(".CustomSizeGuidPage .sizechart-cst .men_tableCus.size-chart-cm-target td").hover(function() {
    console.log("HOVER 2");
    var e = $(this).parent("tr").attr("data-max"),
        t = $(this).attr("data-number");
    $(this).toggleClass("dark_hover"), $(this).prevUntil(".first_colum", "td").toggleClass("light_hover"), $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
    $(this).parent("tr").attr("data-max");
    $(".CustomSizeGuidPage .men_tableCus.size-chart-cm-target thead tr th").each(function() {
      $(this).attr("data-number") == t && $(this).toggleClass("dark_hover")
    }), $(".CustomSizeGuidPage .men_tableCus.size-chart-cm-target tbody  tr").each(function(s) {
      s < e - 1 && $(this).children("td").each(function() {
        $(this).attr("data-number") == t && $(this).toggleClass("light_hover")
      })
    }), $(this).removeClass("light_hover")
  }), $(".CustomSizeGuidPage .sizechart-cst .women_tableCus.size-chart-inches-target td").hover(function() {
    console.log("HOVER 3");
    var e = $(this).parent("tr").attr("data-max"),
        t = $(this).attr("data-number");
    $(this).toggleClass("dark_hover"), $(this).prevUntil(".first_colum", "td").toggleClass("light_hover"), $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
    $(this).parent("tr").attr("data-max");
    $(".CustomSizeGuidPage .women_tableCus.size-chart-inches-target thead tr th").each(function() {
      $(this).attr("data-number") == t && $(this).toggleClass("dark_hover")
    }), $(".CustomSizeGuidPage .women_tableCus.size-chart-inches-target tbody  tr").each(function(s) {
      s < e - 1 && $(this).children("td").each(function() {
        $(this).attr("data-number") == t && $(this).toggleClass("light_hover")
      })
    }), $(this).removeClass("light_hover")
  }), $(".CustomSizeGuidPage .sizechart-cst .women_tableCus.size-chart-cm-target td").hover(function() {
    console.log("HOVER 4");
    var e = $(this).parent("tr").attr("data-max"),
        t = $(this).attr("data-number");
    $(this).toggleClass("dark_hover"), $(this).prevUntil(".first_colum", "td").toggleClass("light_hover"), $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
    $(this).parent("tr").attr("data-max");
    $(".CustomSizeGuidPage .women_tableCus.size-chart-cm-target thead tr th").each(function() {
      $(this).attr("data-number") == t && $(this).toggleClass("dark_hover")
    }), $(".CustomSizeGuidPage .women_tableCus.size-chart-cm-target tbody  tr").each(function(s) {
      s < e - 1 && $(this).children("td").each(function() {
        $(this).attr("data-number") == t && $(this).toggleClass("light_hover")
      })
    }), $(this).removeClass("light_hover")
  }), $(".CustomSizeGuidPage .MenTab").click(function() {
    console.log("free"), $(this).addClass("active"), $(".CustomSizeGuidPage .WomenTab").removeClass("active"), $(".CustomSizeGuidPage #size_cart_men").css("display", "block"), $(".CustomSizeGuidPage #size_cart_women").css("display", "none")
  }), $(".CustomSizeGuidPage .WomenTab").click(function() {
    console.log("freenumber"), $(this).addClass("active"), $(".CustomSizeGuidPage .MenTab").removeClass("active"), $(".CustomSizeGuidPage #size_cart_men").css("display", "none"), $(".CustomSizeGuidPage #size_cart_women").css("display", "block")
  });
  var i = "#video_boxes";
  $(".video_part").click(function() {
    var e = $(this).children("img").attr("data-alt");
    $(".VidWrap .video").html('<source src="' + e + '" type="video/mp4">Your browser does not support the video tag.'), $(i).show()
  }), $(".video_window .video_close").click(function(e) {
    e.preventDefault(), $(i).hide()
  }), $("#video_mask").click(function() {
    $(i).hide()
  })
  $(function () {
    $('.cust-toogletb').click(function () {
      $('.custtabl-nav').slideToggle();
      return false;
    });
  });
  pageSize = 18;

  showPage = function(page) {
    $(".thumbnail ").hide();
    $(".thumbnail ").each(function(n) {
      if (n >= pageSize * (page - 1) && n < pageSize * page)
        $(this).show();
    });        
  }

  showPage(1);

  $("#pagin span").click(function() {

    $("#pagin span").removeClass("current");
    $(this).addClass("current");
    showPage(parseInt($(this).text())) 
  });
  $(".cust-non").click(function(){
    $(".collection_description.CustomDesc").hide();
  });
  $(".custnnfst").click(function(){
    $(".collection_description.CustomDesc").show();
  });

//   $('.cust-non').click(function(){ 
//     $('html,body').animate({ scrollTop: 0 }, 'slow');
//     return false; 
//   });
//   $('.custnnfst').click(function(){ 
//     $('html,body').animate({ scrollTop: 0 }, 'slow');
//     return false; 
//   });
});
$(window).on('load',function(){
   $('.product-recommendations--product .gallery-cell').each(function(){
     var link = $(this).find('a').attr('href');
 var string =link.split('?')[0];
   $(this).find('a').attr('href',string);
    });
})